import React from "react";
import { Routes, Route } from "react-router-dom";
import WikiLanding from "./WikiLanding";
import WikiEditor from "./WikiEditor";
import WikiQA from "./WikiQA";
import RequireAuth from "../RequireAuth";
import RfpFeeder from "./RfpFeeder";
import RdwrDocs from "./rdwr_docs";
import Activity from "./Activity";
import Access from "./Access";
import AppShell from "../components/AppShell";

function WikiRoutes() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<WikiLanding />} />
        <Route
          path="/qa"
          element={
            <RequireAuth>
              <WikiQA />
            </RequireAuth>
          }
        />
        <Route
          path="/activity"
          element={
            <RequireAuth>
              <Activity />
            </RequireAuth>
          }
        />
        <Route
          path="/editor"
          element={
            <RequireAuth>
              <WikiEditor />
            </RequireAuth>
          }
        />
        <Route
          path="/rfp-feeder"
          element={
            <RequireAuth>
              <RfpFeeder />
            </RequireAuth>
          }
        />
        <Route
          path="/rdwr_docs"
          element={
            <RequireAuth>
              <RdwrDocs />
            </RequireAuth>
          }
        />
        <Route
          path="/access"
          element={
            <RequireAuth>
              <Access />
            </RequireAuth>
          }
        />
      </Route>
    </Routes>
  );
}

export default WikiRoutes;
